import { useEffect } from 'react';

/**
 * The tenantless tab title — mirrors index.html's <title> (the pre-mount
 * paint). Kept as a constant so screens can RESTORE it: a dead link, a cold
 * load, or SPA navigation away from a branded flow must never keep (or ever
 * show) a tenant name the server did not serve.
 */
export const STATIC_DOCUMENT_TITLE = 'Video-KYC verification';

/**
 * Browser-tab identity (owner round 2026-08-28 item 4).
 *
 * The tab carries the tenant's name — "EbixCash World Money — Video-KYC" —
 * ONLY when that name came from SERVED branding. The local registry is a
 * dev/mock fallback; its names ("KycHub CRA", sample banks) must never be
 * stamped into a customer's tab: on a white-labelled product that is a third
 * brand nobody configured. No tenant name is ever hardcoded here.
 */
export function brandedDocumentTitle(tenantName: string): string {
  return `${tenantName} — Video-KYC`;
}

/**
 * Stamp the tab with the SERVED tenant name; keep (or restore) the static
 * title while there is none. The cleanup restores the static title on
 * unmount, so SPA navigation to a tenantless screen (dead link, NotFound)
 * never inherits a stale tenant title.
 */
export function useBrandedDocumentTitle(servedName: string | null | undefined): void {
  useEffect(() => {
    document.title = servedName ? brandedDocumentTitle(servedName) : STATIC_DOCUMENT_TITLE;
    return () => {
      document.title = STATIC_DOCUMENT_TITLE;
    };
  }, [servedName]);
}
